// src/pages/AdminDashboard.js
import React, { useState } from "react";
import "../styles/AdminDashboard.css";
import AdminSidebar from "../components/AdminSidebar";
import Users from "../pages/Users";
import Dispatches from "../pages/Dispatches";
import Staff from "../pages/Staff";
import Settings from "../pages/Settings"; // ✅ Import the new Settings page

const AdminDashboard = () => {
  const [activeSection, setActiveSection] = useState("Dashboard");

  const renderSection = () => {
    switch (activeSection) {
      case "Dashboard":
        return (
          <div className="admin-section">
            <div className="admin-header">
              <h2>Dashboard Overview</h2>
              <button className="primary-btn">+ New Dispatch</button>
            </div>
            <div className="analytics-cards">
              <div className="card">
                <h4>Total Dispatches</h4>
                <p>120</p>
              </div>
              <div className="card">
                <h4>Active Users</h4>
                <p>45</p>
              </div>
              <div className="card">
                <h4>Revenue</h4>
                <p>$2,300</p>
              </div>
            </div>
          </div>
        );
      case "Dispatches":
        return <Dispatches />;
      case "Users":
        return <Users />;
      case "Staff":
        return <Staff />;
      case "Settings":
        return <Settings />; // ✅ Load full Settings page
      default:
        return <p>Select a section</p>;
    }
  };

  return (
    <div className="admin-container">
      {/* Sidebar always visible */}
      <AdminSidebar
        activeSection={activeSection}
        setActiveSection={setActiveSection}
      />

      {/* Dynamic content */}
      <div className="admin-main">{renderSection()}</div>
    </div>
  );
};

export default AdminDashboard;
